import { Action } from '@ngrx/store';

import { EditableItem } from '®shared/reading-list';

export enum WithdrawCourseReserveModalActionTypes {
  WITHDRAW_COURSE_RESERVE = '[Withdraw course reserve modal] Withdraw course reserve',
  WITHDRAW_COURSE_RESERVE_SUCCESS = '[Withdraw course reserve modal] Withdraw course reserve success',
  WITHDRAW_COURSE_RESERVE_FAILED = '[Withdraw course reserve modal] Withdraw course reserve failed',
  SHOW_WITHDRAW_COURSE_RESERVE_MODAL = '[Withdraw course reserve modal] Show withdraw course reserve modal',
  HIDE_WITHDRAW_COURSE_RESERVE_MODAL = '[Withdraw course reserve modal] Hide withdraw course reserve modal',
}

export class WithdrawCourseReserveAction implements Action {
  readonly type = WithdrawCourseReserveModalActionTypes.WITHDRAW_COURSE_RESERVE;

  constructor(
    public payload: {
      courseReserveId: string;
      withdrawnListItemId?: string;
      reason: string;
    },
  ) {}
}

export class WithdrawCourseReserveSuccessAction implements Action {
  readonly type =
    WithdrawCourseReserveModalActionTypes.WITHDRAW_COURSE_RESERVE_SUCCESS;

  constructor(public payload: { withdrawnListItemId?: string }) {}
}

export class WithdrawCourseReserveFailedAction implements Action {
  readonly type =
    WithdrawCourseReserveModalActionTypes.WITHDRAW_COURSE_RESERVE_FAILED;

  constructor(public payload: { error: Error }) {}
}

export class ShowWithdrawCourseReserveModalAction implements Action {
  readonly type =
    WithdrawCourseReserveModalActionTypes.SHOW_WITHDRAW_COURSE_RESERVE_MODAL;

  constructor(public payload: { item: EditableItem }) {}
}

export class HideWithdrawCourseReserveModalAction implements Action {
  readonly type =
    WithdrawCourseReserveModalActionTypes.HIDE_WITHDRAW_COURSE_RESERVE_MODAL;

  constructor() {}
}

export type WithdrawCourseReserveModalActions =
  | WithdrawCourseReserveAction
  | WithdrawCourseReserveSuccessAction
  | WithdrawCourseReserveFailedAction
  | ShowWithdrawCourseReserveModalAction
  | HideWithdrawCourseReserveModalAction;
